import {
  Form,
  Dropdown,
  Icon,
  Button,
  Label,
  Image,
  Header,
  Divider,
  Checkbox,
  Rating,
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useEffect, useState } from "react";
const RequestJob = (props) => {
  const {
    isSearching,
    searchQuery,
    setSearchQuery,
    searchResults,
    handleReporterSearch,
    SearchResults,
    selectedJob,
    selectedReporter,
    searchDisabled,
    handleClearReporterSelection,
    handleStartDate,
    handleEndDate,
    handleChangeFieldString,
    page,
    searchMethod,
    setSearchMethod,
    setResults,
    handlePreferredSearch,
    preferredResults,
    handleResultSelect,
    getReporterSelected,
  } = props;

  useEffect(() => {
    handlePreferredSearch();
  }, [selectedJob.start]);

  const timeZoneOptions = [
    { key: "PST", value: "America/Los_Angeles", text: "Pacific (PST)" },
    { key: "MST", value: "America/Denver", text: "Mountain (MST)" },
    { key: "CST", value: "America/Chicago", text: "Central (CST)" },
    { key: "EST", value: "America/New_York", text: "Eastern (EST)" },
    { key: "UTC", value: "UTC", text: "UTC" },
  ];
  return (
    <Form size="large">
      {page === 1 && (
        <div>
          <Form.Group widths={"equal"}>
            <Form.Input
              required
              id="name"
              label="Case Name"
              placeholder="Enter a name for this job"
              value={selectedJob.name || ""}
              onChange={handleChangeFieldString}
            />
            <Form.Input
              required
              id="caseType"
              label="Case Type"
              placeholder="Enter the type of case"
              value={selectedJob.caseType || ""}
              onChange={handleChangeFieldString}
            />
          </Form.Group>
          <Form.Group widths={"equal"}>
            <Form.Input
              required
              id="witnessName"
              label="Witness Name"
              placeholder="Enter a name for the witness"
              value={selectedJob.witnessName || ""}
              onChange={handleChangeFieldString}
            />
            <Form.Input
              required
              id="witnessType"
              label="Witness Type"
              placeholder="e.g. Expert, Doctor, etc."
              value={selectedJob.witnessType || ""}
              onChange={handleChangeFieldString}
            />
          </Form.Group>

          <Form.Group widths={"equal"}>
            <Form.Field id="startDateField" required>
              <label>Start Date / Time:</label>
              <DatePicker
                placeholderText="Select a Date and Time"
                id="start"
                selected={selectedJob.start || ""}
                dateFormat="MMMM d, yyyy h:mm aa"
                showTimeSelect
                timeIntervals={30}
                minDate={new Date()}
                onChange={handleStartDate}
                fixedHeight
              />
            </Form.Field>

            <Form.Field id="endDateField" required>
              <label>End Date / Time:</label>
              <DatePicker
                placeholderText="Select a Date and Time"
                id="end"
                selected={selectedJob.end || ""}
                dateFormat="MMMM d, yyyy h:mm aa"
                showTimeSelect
                timeIntervals={30}
                minDate={selectedJob.start || new Date()}
                onChange={handleEndDate}
                fixedHeight
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths={"equal"}>
            <Form.Select
              required
              id="timeZone"
              require
              options={timeZoneOptions}
              value={selectedJob.timeZone}
              selection
              label="Time Zone"
              placeholder="Select Time Zone"
              onChange={handleChangeFieldString}
            />
            <Form.Input
              required
              id="location"
              label="Job Location"
              placeholder="Enter location's physical address, or 'Remote'"
              value={selectedJob.location || ""}
              onChange={handleChangeFieldString}
            />
          </Form.Group>
          <Form.Group widths={"equal"}>
            <Form.Input
              id="claimNumber"
              label="Claim Number"
              placeholder="Enter the claim number (if insurance related)"
              value={selectedJob.claimNumber || ""}
              onChange={handleChangeFieldString}
            />
            <Form.Input
              id="insuranceCarrier"
              label="Insurance Carrier"
              placeholder="Enter the Insurance Carrier (if insurance related)"
              value={selectedJob.insuranceCarrier || ""}
              onChange={handleChangeFieldString}
            />
          </Form.Group>
          <Form.Input
            id="clientMatterNumber"
            label="Client Matter #"
            placeholder="Enter Client Matter #"
            value={selectedJob.clientMatterNumber || ""}
            onChange={handleChangeFieldString}
          />

          <Divider horizontal section>
            Optional Services
          </Divider>
          {/* <Form.Checkbox
            id="requestedRealtime"
            label="Realtime Transcript"
            checked={selectedJob.requestedRealtime}
            onChange={handleChangeFieldString}
          /> */}
          <Form.Checkbox
            id="requestedRemote"
            label="Remote Services (Video, Realtime, etc.)"
            checked={selectedJob.requestedRemote}
            onChange={handleChangeFieldString}
          />
          <Form.Checkbox
            id="requestedVideographer"
            label="Videographer"
            checked={selectedJob.requestedVideographer}
            onChange={handleChangeFieldString}
          />
          <Form.Checkbox
            id="requestedInterpreter"
            label="Interpreter"
            checked={selectedJob.requestedInterpreter}
            onChange={handleChangeFieldString}
          />
          {selectedJob.requestedInterpreter && (
            <Form.Input
              id="interpreterLanguage"
              label="Interpreter Language"
              placeholder="e.g. English, Spanish, etc."
              value={selectedJob.interpreterLanguage || ""}
              onChange={handleChangeFieldString}
            />
          )}
          <Form.TextArea
            id="additionalRequests"
            label="Additional Requests"
            placeholder="Enter any special requests for services, deliverables, dates, etc."
            value={selectedJob.additionalRequests || ""}
            onChange={handleChangeFieldString}
          />
        </div>
      )}
      {page === 2 && (
        <div>
          {preferredResults?.length > 0 && (
            <div
              style={{
                backgroundColor: "#FFFFFF",
                padding: "20px",
                borderRadius: "20px",
              }}
            >
              <div style={{ display: "flex" }}>
                <Header
                  style={{ margin: "0px" }}
                  content="Your Preferred Reporter is:"
                />
                <Label
                  basic
                  content={
                    preferredResults[0].isAvailable
                      ? "Available"
                      : "Not Available"
                  }
                  color={preferredResults[0].isAvailable ? "green" : "red"}
                />
              </div>
              <div>
                {preferredResults[0].isAvailable
                  ? "You can select this reporter or search for another reporter below."
                  : "Click Previous to go back and change the date/time if you wish to use your preferred reporter, or you can search for another reporter below."}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <Image
                  style={{
                    width: "75px",
                    height: "75px",
                    borderRadius: "10px",
                  }}
                  src={preferredResults[0].photoLink}
                />
                <Header style={{ marginTop: "0px", marginLeft: "10px" }}>
                  {preferredResults[0].fullName}
                  <Header.Subheader>
                    {preferredResults[0].dbaName}
                  </Header.Subheader>
                  <Header.Subheader>
                    {preferredResults[0].location}
                  </Header.Subheader>
                  <Header.Subheader
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Rating:{" "}
                    {
                      <Rating
                        icon="star"
                        disabled
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                        maxRating={5}
                        rating={parseInt(preferredResults[0].averageRating)}
                      />
                    }{" "}
                    (from {preferredResults[0].numRatings} ratings)
                  </Header.Subheader>
                </Header>
              </div>
              {preferredResults[0].isAvailable && (
                <div style={{ marginTop: "10px" }}>
                  <Button
                    disabled={getReporterSelected()}
                    size="large"
                    content="Select Preferred Reporter"
                    primary
                    onClick={() => handleResultSelect(preferredResults[0])}
                  />
                </div>
              )}
            </div>
          )}
          {preferredResults?.length > 0 && <Divider section />}

          <Form.Field>
            <Header>
              Search Method
              <Header.Subheader>
                You can search for avialable Court Reporters by Zip Code, City,
                or Name. All reporters matching your search criteria will be
                shown, with available reporters selectable on top.
              </Header.Subheader>
            </Header>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "50%",
              }}
            >
              <Checkbox
                radio
                label="Zip Code"
                checked={searchMethod === "Zip Code"}
                onClick={() => {
                  setSearchMethod("Zip Code");
                  handleClearReporterSelection();
                }}
              />
              <Checkbox
                radio
                label="City"
                checked={searchMethod === "City"}
                onClick={() => {
                  setSearchMethod("City");
                  handleClearReporterSelection();
                }}
              />
              <Checkbox
                radio
                label="Name"
                checked={searchMethod === "Name"}
                onClick={() => {
                  setSearchMethod("Name");
                  handleClearReporterSelection();
                }}
              />
            </div>
          </Form.Field>
          <Form.Field
            style={{ height: searchResults?.length > 0 ? "400px" : "" }}
          >
            <label>Search Reporters</label>
            <Dropdown
              direction="up"
              disabled={searchDisabled}
              icon={
                <Icon
                  loading={isSearching}
                  name="search"
                  style={{ margin: "0px", padding: "0px" }}
                />
              }
              selection
              search
              scrolling
              id="reporterSearch"
              placeholder={`Search by ${searchMethod}...`}
              searchQuery={searchQuery || ""}
              onSearchChange={(e) => setSearchQuery(e.target.value)}
              open={searchResults && searchResults.length > 0}
              action={
                <Button content="Search" onClick={handleReporterSearch} />
              }
              onBlur={() => setResults([])}
            >
              <Dropdown.Menu>
                <SearchResults />
              </Dropdown.Menu>
            </Dropdown>
          </Form.Field>
          {selectedReporter.fullName && (
            <Form.Field>
              <label>Selected Reporter:</label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Image
                  style={{
                    width: "75px",
                    height: "75px",
                    borderRadius: "10px",
                  }}
                  src={selectedReporter.photoLink}
                />
                <Header style={{ marginTop: "0px", marginLeft: "10px" }}>
                  {selectedReporter.fullName}
                  <Header.Subheader>
                    {selectedReporter.dbaName}
                  </Header.Subheader>
                  <Header.Subheader>
                    {selectedReporter.location}
                  </Header.Subheader>
                  <Header.Subheader
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Rating:{" "}
                    {
                      <Rating
                        icon="star"
                        disabled
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                        maxRating={5}
                        rating={parseInt(selectedReporter.averageRating)}
                      />
                    }{" "}
                    (from {selectedReporter.numRatings} ratings)
                  </Header.Subheader>
                </Header>
                <Icon
                  className="custom-button"
                  name="close"
                  style={{ marginLeft: "10px" }}
                  onClick={handleClearReporterSelection}
                />
              </div>
            </Form.Field>
          )}
        </div>
      )}
    </Form>
  );
};
export default RequestJob;
